import React from 'react'
import {
  Permission,
  PermissionValue,
  getGroupedPermissions,
  buildPermissionTree,
  hasVisiblePermissions,
} from '../utils'
import { PermissionGroup } from './PermissionGroup'

interface PermissionsEditorProps {
  permissions: Permission[]
  currentPermissions: PermissionValue[]
  onPermissionChange: (updatedPermissions: PermissionValue[]) => void
}

export const PermissionsEditor: React.FC<PermissionsEditorProps> = ({
  permissions,
  currentPermissions,
  onPermissionChange,
}) => {
  // Функция для получения текущего значения права
  const getPermissionValue = (permissionId: number) => {
    const permission = currentPermissions.find(item => item.id === permissionId)
    return permission?.value !== undefined ? permission.value : null
  }

  // Обработчик изменения checkbox
  const handlePermissionChange = (e: any) => {
    const { value, checked } = e.target
    let updatedPermissions = [...currentPermissions]

    if (checked) {
      const existingIndex = updatedPermissions.findIndex(item => item.id === value)
      if (existingIndex >= 0) {
        updatedPermissions[existingIndex] = { id: value, value: checked }
      } else {
        updatedPermissions.push({ id: value, value: checked })
      }
    } else {
      updatedPermissions = updatedPermissions.filter(item => item.id !== value)
    }

    onPermissionChange(updatedPermissions)
  }

  // Обработчик изменения select
  const handleChangeSelect = (value: string | null, id: number) => {
    let updatedPermissions = [...currentPermissions]
    const permissionIndex = updatedPermissions.findIndex(item => item.id === id)

    if (value) {
      if (permissionIndex >= 0) {
        updatedPermissions[permissionIndex] = { id, value }
      } else {
        updatedPermissions.push({ id, value })
      }
    } else {
      updatedPermissions = updatedPermissions.filter(item => item.id !== id)
    }

    onPermissionChange(updatedPermissions)
  }

  const groupedPermissions = getGroupedPermissions(permissions)

  return (
    <div style={{ overflowY: 'auto', paddingRight: '8px', width: 790 }}>
      {groupedPermissions.map(group => {
        const permissionTree = buildPermissionTree(group.permissions)

        // Проверяем, есть ли в группе видимые права
        if (!hasVisiblePermissions(permissionTree, permissions, getPermissionValue)) {
          return null
        }

        return (
          <PermissionGroup
            key={group.groupId}
            groupName={group.groupName}
            permissionTree={permissionTree}
            permissions={permissions}
            getPermissionValue={getPermissionValue}
            onCheckboxChange={handlePermissionChange}
            onSelectChange={handleChangeSelect}
          />
        )
      })}
    </div>
  )
}
